<app-blade-header [bladeIndex]="bladeIndex">
  @if (title$ | async; as title) {
    <ng-container title>
      {{title}}
    </ng-container>
  }
</app-blade-header>

@if (items) {
  @if (items.length > 0) {
    <app-compact-list
      [items]="items"
      [columns]="columns"
      (itemSelected)="itemSelected($event)"
      (columnsUpdated)="columnsUpdated($event)">
    </app-compact-list>
  }
} @else {
  <div class="py-4">
    <places-spinner [small]="true"></places-spinner>
  </div>
}
